import React, {
  useCallback,
  useMemo,
  useState,
  useEffect,
  useRef,
  Suspense,
} from 'react';
import { Link, useRouter } from 'found';
import { truncate } from 'lodash';
import strip from 'strip';
import './EventDetails.css';
import { useAuthContext } from 'AuthContext';
import Main from 'ripple/Containers/Main';
import makeStyles from '@mui/styles/makeStyles';
import HTMLFragment from 'components/HTMLFragment';
// import EventCard from 'containers/cards/Event';
import Button from '@mui/material/Button';
import CardActions from '@mui/material/CardActions';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Typography from '@mui/material/Typography';
import NoSsr from '@mui/material/NoSsr';
import HeroCarousel from 'ripple/Components/HeroCarousel';
import { isInviteOnlyEvent } from 'lib/eventUtils';
import EventMeta from 'ripple/Events/EventMeta';
import useIsMobile from 'lib/useIsMobile';
import RowSpacer from 'components/RowSpacer';
import tracker from 'lib/tracker';
// import ProductCard from 'containers/cards/Product';
import Card from 'components/Card';
import CommentForm from 'components/CommentForm';
import Flag from '@mui/icons-material/Flag';
import { useTheme } from '@mui/material';
import { useApolloClient, useQuery, useLazyQuery } from '@apollo/client';
import IconBasedTimeline from '../Components/Timeline/IconBasedTimeline';
import {
  GET_EVENT_DEATILS_INFO,
  GET_PRODUCT_INFO,
  GET_ACTIVITY_GROUP,
} from '../../schema/apolloQueries/eventDeatilsQueries';
import { isEmpty } from '../../utils/validators';
import { GET_PROFILE_INFO } from '../../schema/apolloQueries/commonQueries';
import { useAudienceTrackerContext } from '../../lib/trackers/Audience';
import apiGateway from '../../lib/apiGateway';
import { convertEventMilestonesToTimeline } from './timeLineHelper';
import SponsorMessage from '../../pages/Community/SponsorMessage';
import PaidMediaDialog from './Dialogs/PaidMediaDialog';

const Activities = React.lazy(() => import('activities/Activities'));
const Feed = React.lazy(() => import('feed/Feed'));

const useStyles = makeStyles(theme => ({
  cont: {
    color: theme.palette.text.primary,
    fontSize: 16,
    fontWeight: 400,
    padding: 20,
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
    overflow: 'hidden',
    textAlign: 'justify',
  },
  compact: {
    paddingLeft: 0,
  },
  main: {
    color: '#fff',
    right: '0',
  },
  meta: {
    left: '0',
  },

  desc: {
    paddingLeft: 20,
    paddingRight: 60,
  },

  descMobile: {
    paddingLeft: 20,
    paddingRight: 20,
  },
}));

const EventDetails = () => {
  const [isAlert, setAlert] = useState(false);

  const {
    match: {
      location: { pathname },
      params: eventSlug,
    },
    router,
  } = useRouter();
  const { trackView, trackAction } = useAudienceTrackerContext();
  const { data, error, loading } = useQuery(GET_EVENT_DEATILS_INFO, {
    variables: { slug: encodeURIComponent(eventSlug.eventSlug) },
  });

  const getUtmParams = () => {
    let sessionSource = sessionStorage.getItem('rs_session_source') || null;
    if (sessionSource) {
      sessionSource = JSON.parse(sessionSource);
    }
    const { location: { search } } = window;
    if (search) {
      let queryParams = search.replace('?', '').split('&');
      queryParams = queryParams.filter((qp) => qp.indexOf('utm_') === 0);
      if (queryParams.length) {
        sessionSource = queryParams.filter(q => q).map((qp) => {
          const keyvalue = (qp || '').trim().split('=');
          const param = {};
          if (keyvalue.length === 2) {
            [param.name, param.value] = keyvalue;
          }
          return param;
        }).reduce((p, c) => {
          const { name, value } = c;
          const updated = { ...p, [name.replace('utm_', '')]: value };
          return updated;
        }, {});
        sessionStorage.setItem('rs_session_source', JSON.stringify(sessionSource));
      }
    }
    return sessionSource;
  };
  useEffect(() => {
    if (
      !loading
      && error
      && JSON.parse(error?.message)
      && JSON.parse(error?.message)?.status === 'NOT_FOUND'
    ) {
      setAlert(true);
    }
  }, [loading, error]);

  const client = useApolloClient();
  const [getActivityGroup, { data: activityGroupData }] = useLazyQuery(
    GET_ACTIVITY_GROUP,
    {
      variables: {
        eventId: 0,
      },
    },
  );
  const profileData = client.readQuery({
    query: GET_PROFILE_INFO,
  });
  const activitiesList = useRef(null);
  const isMobile = useIsMobile();
  const theme = useTheme({ isMobile });
  const feedRef = useRef(null);
  const { showSignInDialog } = useAuthContext();
  const [feedMF, setFeedMF] = useState(null);
  const [creatingComment, setCreatingComment] = useState(false);
  const [activitiesRendered, setActivitiesRendered] = useState(null);
  const [showPaidMedia, setShowPaidMedia] = useState(false);

  const [product, setProduct] = useState();
  const colSize = useMemo(() => {
    if (!isMobile) {
      return { left: 4, right: 2, reviewCard: 3, imageCard: 2 };
    }
    return { left: 6, right: 6, reviewCard: 6, imageCard: 3 };
  }, [isMobile]);

  const styles = {
    empty: {
      minHeight: '20vh',
      justifyContent: 'center',
      alignItems: 'center',
    },
    feedCard: {
      marginBottom: 10,
      marginTop: 10,
      marginLeft: 20,
      maxWidth: isMobile ? '95vw' : '60vw',
    },
  };

  const classes = useStyles();
  const eventId = data?.getEventDetailBySlug?.id;
  const sponsorId = data?.getEventDetailBySlug?.community?.id;
  const categories = data?.getEventDetailBySlug?.categories;
  const personId = profileData?.getProfile?.personId
    ? profileData?.getProfile?.personId
    : null;
  const eventType = data?.getEventDetailBySlug?.eventType;
  const slug = data?.getEventDetailBySlug?.slug;
  useEffect(() => {
    if (personId) {
      getActivityGroup();
    }
  }, [personId]);
  useEffect(() => {
    if (!isEmpty(eventId)) {
      client
        .query({
          query: GET_PRODUCT_INFO,
          variables: {
            eventId,
          },
        })
        .then(res => {
          if (res?.data?.getProduct) {
            setProduct(res?.data?.getProduct);
          } else {
            setProduct(null);
          }
        });
    }
  }, [eventId]);

  let productId;
  if (Array.isArray(product) && product.length > 0) {
    productId = product[0]?.id;
  }

  const metaTitle = useMemo(
    () => `${strip(data?.getEventDetailBySlug?.community?.name)} ${strip(
        data?.getEventDetailBySlug?.name,
      )}`,
    [
      data?.getEventDetailBySlug?.community.name,
      data?.getEventDetailBySlug?.name,
    ],
  );

  const metaDescription = useMemo(
    () => `${
        data?.getEventDetailBySlug?.summary
          ? strip(data?.getEventDetailBySlug?.summary)
          : truncate(strip(data?.getEventDetailBySlug?.description), {
              length: 140,
              separator: ' ',
            })
      } #sponsored`,
    [
      data?.getEventDetailBySlug?.description,
      data?.getEventDetailBySlug?.summary,
    ],
  );

  const heroAssetUrl = data?.getEventDetailBySlug?.heroPlaylist?.assets[0]?.url;

  const meta = useMemo(
    () => [
      {
        property: 'og:type',
        content: 'article',
      },
      {
        property: 'og:tag',
        content: 'sponsored',
      },
      {
        property: 'og:title',
        content: metaTitle,
      },
      {
        property: 'og:description',
        content: metaDescription,
      },
      heroAssetUrl
        ? {
            property: 'og:image',
            content: heroAssetUrl,
          }
        : {},
      {
        property: 'twitter:card',
        content: 'summary_large_image',
      },
      {
        property: 'twitter:title',
        content: metaTitle,
      },
      {
        property: 'twitter:description',
        content: metaDescription,
      },
      heroAssetUrl
        ? {
            property: 'twitter:image',
            content: heroAssetUrl,
          }
        : {},
    ],
    [heroAssetUrl, metaDescription, metaTitle],
  );

  const timeData = data?.getEventDetailBySlug?.milestones
    && convertEventMilestonesToTimeline(
      data?.getEventDetailBySlug?.milestones,
      eventType,
    );

  const reviewFirst = false; // useMemo(() => reviewTotalCount === 0, [reviewTotalCount]);

  // const faqs = event.faq ? (
  //   <Faq faq={event.faq} eventDetailsTab />
  // ) : (
  //   <Empty style={styles.empty} title='No Faqs found' />
  // );

  // const favors = (
  //   <InfiniteScroller
  //     empty={event.favors.totalCount === 0}
  //     emptyText='Check back soon for new favors'
  //     emptyTitle="This event doesn't have any favors yet!"
  //     relay={relay}
  //     pageSize={pageSize}
  //     scrollId='favorsContainer'
  //     varName='favorsPageSize'
  //   >
  //     <FavorList favorConnection={event.favors} viewer={viewer} />
  //   </InfiniteScroller>
  // );

  useEffect(() => {
    if (profileData && data && !profileData?.getProfile?.personId) {
      const utmParam = getUtmParams();
      if (utmParam && utmParam?.medium === 'paid' && utmParam?.campaign === '1592_KraftMacCheese_Recruitment_PaidSocial_Sept2024') {
        trackView('welcome_to_community', {
          page_name: metaTitle,
          page_url: pathname,
          event_slug: eventSlug.eventSlug,
          event_id: eventId,
        });
        setShowPaidMedia(true);
      }
    }
  }, [profileData, data]);

  const replaceRegex = /((color:( )?#000000)|(background-color:( )?#ffffff))/g;

  const onCreate = (
    input,
    {
      resetForm = () => {},
      setErrors = () => {},
      setSubmitting = () => {},
    } = {},
  ) => {
    setCreatingComment(true);
    const { getActivityGroup: getAG } = activityGroupData;
    const task = getAG[0].activities[0]?.tasks.find(
      tsk => tsk.name === 'DISCUSSION',
    );
    const conversation = {
      activityGroupId: getAG[0].id || '',
      activityId: getAG[0].activities[0]?.id || '',
      eventId,
      sponsorId,
      userId: personId,
      tasks: [
        {
          task: 'DISCUSSION',
          taskId: task?.id || '',
          request: {
            body: input.body,
            productId: eventId,
            productName: 'Event',
          },
        },
      ],
    };
    apiGateway
      .postJoinConversation(conversation)
      .then(res => {
        if (res) {
          setSubmitting(false);
          setCreatingComment(false);
          setFeedMF(null);
          trackAction('joined_event_conversation', {
            event_id: eventId,
            sponsor_id: sponsorId,
            event_type: eventType,
            event_category: (categories || []).map(c => c.name),
          });
        }
      })
      .catch(e => {
        setErrors(e);
        setSubmitting(false);
        setCreatingComment(false);
      });
    resetForm();
  };
  // const faqsCount = useMemo(() => {
  //   const {
  //     topics = [],
  //   } = event.faq || {};
  //   const questions = topics.map(t => t.items.length);
  //   return questions.reduce((a, n) => a + n, 1);
  // }, [event]);

  const handleCompleteStandardActivity = useCallback(() => {
    router.push(`/events/${data?.getEventDetailBySlug?.slug}/activities`);
  }, [router, data?.getEventDetailBySlug?.slug]);

  const handleActivityCompletion = useCallback(
    (/* {
      detail: {
        tasks,
      },
    } */) => {
      // tasks.forEach((feedItem) => {
      //   let relayVariable = '';
      //   switch (feedItem) {
      //     case 'photos':
      //       relayVariable = 'photoPageSize';
      //       break;
      //     case 'reviews':
      //       relayVariable = 'reviewPageSize';
      //       break;
      //     default:
      //       break;
      //   }
      //   if (relayVariable) {
      //     relay.forceFetch({ [relayVariable]: 10 });
      //   }
      // });
    },
    [],
  );

  const removeGlobalEventListeners = useCallback(() => {
    document.removeEventListener(
      'CompleteStandardActivity',
      handleCompleteStandardActivity,
    );
    document.removeEventListener('ActivityCompleted', handleActivityCompletion);
  }, [handleActivityCompletion, handleCompleteStandardActivity]);

  const addGlobalEventListeners = useCallback(() => {
    removeGlobalEventListeners();
    document.addEventListener(
      'CompleteStandardActivity',
      handleCompleteStandardActivity,
    );
    document.addEventListener('ActivityCompleted', handleActivityCompletion);
  }, [
    handleActivityCompletion,
    handleCompleteStandardActivity,
    removeGlobalEventListeners,
  ]);

  useEffect(() => {
    if (data?.getEventDetailBySlug) {
      tracker.trackGoogleTagManagerEvent(
        'view_item',
        'view_item',
        {
          event: {
            ...data?.getEventDetailBySlug,
            listName: 'Applications Now Open',
          },
          viewer: profileData?.getProfile?.personInfo,
        },
        true,
      );
      // if (!event.application && ['rmpschardonnaychat', 'svedkahalloween', 'rmpsspiritsbarrelsaged'].indexOf(data?.getEventDetailBySlug?.slug) > -1 && acceptingApplicants && !isPast(data?.getEventDetailBySlug?.milestones?.applicationEndDate)) {
      //   router.push(`/events/${data?.getEventDetailBySlug?.slug}/view`);
      // }
    }
  }, [slug, eventType]);

  useEffect(() => {
    const mobileAgent = /iPhone|iPad|Android/i.test(navigator.userAgent);
    try {
      const queryParams = new URLSearchParams(window.location.search);
      if (queryParams && queryParams.get('activity')) {
        const activityId = queryParams.get('activity');
        if (mobileAgent && activityId && +eventId !== 1393) {
          window.location = `ripplestreet://ripplestreet?activity=${activityId}`;
        }
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Error while extracting the target activity');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (eventId) {
      trackView('event_details', {
        page_name: metaTitle,
        page_url: pathname,
        event_slug: eventSlug.eventSlug,
        event_id: eventId,
      });
    }
  }, [eventId, eventSlug.eventSlug]);

  useEffect(() => {
    if (personId && eventId) {
      if (activitiesList.current && !activitiesRendered) {
        const stdActivities = [];
        setActivitiesRendered(
          <Suspense fallback='loading...'>
            <Activities
              context={{
                eventId,
                sponsorId,
                userId: personId,
                productId,
                standardActivities: stdActivities,
                themeType: theme.palette.mode,
                eventType,
                eventCategory: (categories || []).map(c => c.name),
              }}
            />
          </Suspense>,
        );
      }
      addGlobalEventListeners();
    }
    return () => {
      removeGlobalEventListeners();
    };
  }, [
    activitiesList,
    data?.getEventDetailBySlug,
    eventId,
    personId,
    productId,
    sponsorId,
    addGlobalEventListeners,
    removeGlobalEventListeners,
    activitiesRendered,
    theme.palette.mode,
    eventType,
  ]);

  useEffect(() => {
    if (feedRef.current && !feedMF && eventId && profileData) {
      setFeedMF(
        <Suspense fallback='Loading Feed...'>
          <Feed
            context={{
              modelType: 'Event',
              eventId,
              eventSlug: slug,
              personId,
              sponsorId,
              eventType,
              loggedIn: profileData?.getProfile?.loggedIn,
              email: profileData?.getProfile?.personInfo?.email,
              showSignInDialog,
              enabledFeedTypes: [
                {
                  type: 'SocialAsset',
                  label: 'Photos & Videos',
                },
                'Discussion',
                'Review',
                'FAQ',
              ],
            }}
            themeType={theme.palette.mode}
          />
        </Suspense>,
      );
    }
  }, [
    eventId,
    slug,
    personId,
    showSignInDialog,
    profileData,
    feedMF,
    feedRef,
    theme.palette.mode,
  ]);

  if (isAlert) {
    return (
      <SponsorMessage
        message={`We couldn't find the events you're looking for. Don't worry, explore a
     variety of amazing events on our list!`}
        open={isAlert}
        onClick={() => {
          window.location.replace('/discover/events');
        }}
      />
    );
  }
  return (
    <>
      {showPaidMedia && (<PaidMediaDialog open={showPaidMedia} onCancel={() => setShowPaidMedia(false)} />)}
      <Main meta={meta} title={metaTitle}>
        <NoSsr>
          <HeroCarousel
            compact={false}
            refreshActivities={setActivitiesRendered}
            event={data?.getEventDetailBySlug}
            viewer={profileData?.getProfile}
            playlist={data?.getEventDetailBySlug?.heroPlayList}
          />
        </NoSsr>
        {eventType !== 'REFUND' && (
          <div ref={activitiesList} style={{ margin: '0px 0 20px' }}>
            {activitiesRendered}
          </div>
        )}
        <NoSsr>
          {!isInviteOnlyEvent(eventId) && eventType !== 'REFUND' && (
            <ImageList spacing={0} className={classes.cont} cols={6}>
              <ImageListItem cols={12}>
                <IconBasedTimeline
                  size={14}
                  steps={timeData?.timeLine}
                  activeStep={timeData?.actStep}
                />
              </ImageListItem>
            </ImageList>
          )}
          <ImageList spacing={0} className={classes.cont} cols={6}>
            <ImageListItem
              className={classes.main}
              meta
              style={{ textAlign: 'left' }}
              cols={colSize.right}
              rows={-1}
            >
              <EventMeta
                event={data?.getEventDetailBySlug}
                viewer={profileData?.getProfile}
              />
            </ImageListItem>

            <ImageListItem
              main
              className={classes.compact}
              cols={colSize.left}
              rows={-1}
            >
              {!isInviteOnlyEvent(eventId) && (
                <Typography
                  color='primary'
                  variant={isMobile ? 'subtitle1' : 'h6'}
                  classes={{ root: isMobile ? classes.descMobile : classes.desc }}
                >
                  Packs Available: {data?.getEventDetailBySlug?.displayLimit} |
                  Members Applied:{' '}
                  {
                    data?.getEventDetailBySlug?.packAndApplicationCount
                      ?.noOfApplicant
                  }
                </Typography>
              )}
              <div className={isMobile ? classes.descMobile : classes.desc}>
                <HTMLFragment>
                  {data?.getEventDetailBySlug?.description.replace(
                    replaceRegex,
                    '',
                  )}
                </HTMLFragment>
              </div>
              <Card style={styles.feedCard}>
                <CommentForm
                  personId={personId}
                  first={reviewFirst}
                  onSave={onCreate}
                  saving={creatingComment}
                />
              </Card>
              <CardActions classes={{ root: classes.desc }}>
                <RowSpacer />
                <Button variant='contained' color='error' startIcon={<Flag />}>
                  <Link to='/support'>Contact Support</Link>
                </Button>
              </CardActions>
            </ImageListItem>
          </ImageList>
        </NoSsr>
        <div
          ref={feedRef}
          style={{ width: '100%', minHeight: 300, margin: '0px 0 20px' }}
        >
          {feedMF}
        </div>
      </Main>
    </>
  );
};

export default EventDetails;
